import { useRef } from "react";
import { cardToDeleteStore } from "features/CardToDelete";
import { openedCardStore } from "features/OpenedCard";
import { useMainViewScrollRestoration } from "features/Panel/hooks/Panel.hooks";
import { useCardHandlers } from "features/Panel/hooks/Panel.hooks";
import { useRailCardActions } from "features/RailCardActions/model/hooks/useRailCardActions";
import { useRailSearch } from "features/Search";
import { authStore } from "entities/Auth";
import { Card, ErrorCard, LoadCard } from "entities/Card";
import { PanelView } from "entities/PanelView";
import { railSearchCardStore } from "entities/RailSearchCard";
import { RailSearchCard } from "entities/RailSearchCard/ui/RailSearchCard";
import { searchFilterStore } from "entities/SearchFilter";
import { mainViewId, searchShipmentLoadingText } from "shared/constants/panel.constants";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";

type RailViewProps = {
  className?: string;
};

export const RailView: RFC<RailViewProps> = ({ className }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const railSearchCards = useAppSelector(railSearchCardStore.selectors.searchCards);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);
  const { isRailSearchLoading } = useRailSearch({ isAuthenticated });
  const { openCard } = useCardHandlers({
    openedCardAction: openedCardStore.actions.setOpenedCardAction,
  });
  const { deleteRailCardHandler } = useRailCardActions({
    setCardToDeleteAction: (card) => ({
      type: cardToDeleteStore.actions.setCardToDeleteAction.type,
      payload: card,
    }),
    resetCardToDeleteAction: () => ({
      type: cardToDeleteStore.actions.resetCardToDeleteAction.type,
    }),
    // removeFilteredCardAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // removeCardByTagAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // refreshTags: () => {},
  });

  useMainViewScrollRestoration(containerRef);

  return (
    <PanelView ref={containerRef} className={className} id={mainViewId}>
      {isRailSearchLoading && <LoadCard text={t(searchShipmentLoadingText)} />}

      {railSearchCards.map((card, index) => (
        <RailSearchCard
          key={card.reference ?? index}
          data={card}
          openCard={openCard}
          deleteCardHandler={deleteRailCardHandler}
          shipmentType={shipmentType}
          renderCard={(props) => <Card {...props} />}
          renderErrorCard={(props) => <ErrorCard {...props} />}
        />
      ))}
    </PanelView>
  );
};
